/**
 * The once-only rule for reloading after a stale deploy (D-066): a page that could not load one
 * of its code chunks reloads itself, unless it already did so in the last `RELOAD_WINDOW_MS`, so
 * a chunk that is really broken never makes the page loop. Pure; the timestamp lives in
 * sessionStorage under `RELOAD_KEY` (one tab's history, cleared with the tab).
 */
export const RELOAD_KEY = 'runkr.chunkReload'
export const RELOAD_WINDOW_MS = 10_000

/** The stored timestamp (ms since epoch), or null when missing or not a number. */
export function parseReloadAt(raw: string | null | undefined): number | null {
  if (raw === null || raw === undefined || raw === '') return null
  const n = Number(raw)
  return Number.isFinite(n) ? n : null
}

/**
 * May the page reload itself now? Yes when it has not done so yet, or the last time was more
 * than `windowMs` away (either way, so a clock that jumped back far does not block it forever).
 */
export function canAutoReload(
  lastAt: number | null,
  now: number,
  windowMs: number = RELOAD_WINDOW_MS,
): boolean {
  return lastAt === null || Math.abs(now - lastAt) > windowMs
}
